export const TOAST_AUTO_CLOSE_MS = 10_000;
